import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import {
  PercentualLoyalty,
  RegularBenefitVariant,
} from '../../../../../../../typings'
import { messages } from './messages'

export function validationSuitePercentualLoyalty(intl: IntlShape) {
  return create(({ value, status, type }: PercentualLoyalty) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.PercentualLoyalty, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })

        test('value', $t(validation.lessThanOrEquals, { value: 100 }), () => {
          enforce(value).lessThanOrEquals(100)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })

      test('status', $t(validation.required), () => {
        enforce(status).isNotEmpty()
      })
    })
  })
}
